module.exports = __webpack_public_path__ + "static/media/OE-Leonie-dashboard-en.e2331b77.jpg";